





































































import { Component, Vue } from 'vue-property-decorator';
import { date } from 'quasar';
import formatDate = date.formatDate;

@Component
export default class OrdersTab extends Vue {
  formatDate = formatDate;
  orders = [
    {
      id: 1,
      orderNumber: 1230,
      bookingDate: new Date(),
      products: [
        {
          checkInDate: new Date(),
          checkOutDate: new Date(),
          displayName: 'Standart Room Land View',
          concept: 'All Inclusive',
          type: 'PROPERTY',
          adults: [
            { name: 'Eldar', surname: 'Makienko' },
            { name: 'Ülker', surname: 'Makienko' },
          ],
          children: [
            { name: 'Ela', surname: 'Makienko' },
            { name: 'Melina', surname: 'Makienko' },
          ],
        },
        {
          checkInDate: new Date(),
          checkOutDate: new Date(),
          displayName: 'Standart Room Land View',
          concept: 'All Inclusive',
          type: 'PROPERTY',
          adults: [{ name: 'Harun', surname: 'İşci' }],
          children: [{ name: 'Bertiz', surname: 'İşci' }],
        },
        {
          checkInDate: new Date(),
          checkOutDate: new Date(),
          displayName: 'Standart Room Land View',
          concept: 'All Inclusive',
          type: 'PROPERTY',
          adults: [{ name: 'Burak', surname: 'Öz' }],
          children: [],
        },
      ],
    },
  ];
}
